import PlaneIcon from '@components/icons/TransportIcons/PlaneIcon';
import ShipIcon from '@components/icons/TransportIcons/ShipIcon';
import TrainIcon from '@components/icons/TransportIcons/TrainIcon';
import TruckIcon from '@components/icons/TransportIcons/TruckIcon';
import LocationOrTerminalPoint from '@components/pages/LocationOrTerminalPoint';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { RoutesGroup } from '@services/requests/orderService/types';
import { BranchItem } from '@services/requests/routeCalculator/locationsBranchSearchService/interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RouteWidgetParams } from '../../../types';
import { RouteShoulderContainer } from './StyledComponents';

/**
 * Пропсы компонента
 */
export type RouteShoulderProps = {
  startLocation: BranchItem;
  startContractorName: string;
  endLocation: BranchItem;
  endContractorName: string;
  deliveryDays: number;
  routeStepTypes: string[];
  routeStepCargoTypes: string[];
};

const TransportIcons = (t: string) => {
  switch (t) {
    case '1':
      return ShipIcon;
    case '2':
      return TrainIcon;
    case '3':
      return PlaneIcon;
  }

  return TruckIcon;
};

/**
 * Компонент вывода описания плеча маршрута
 * @param props
 */
const RouteShoulder = (
  props: RouteShoulderProps & {
    route: RoutesGroup;
    stepIndex: number;
    routeParams: RouteWidgetParams;
  }
) => {
  const {
    startLocation,
    endLocation,
    deliveryDays,
    routeStepTypes = [],
    routeStepCargoTypes,
    route,
    stepIndex,
    routeParams,
  } = props;

  const { t } = useTranslation(['Common', 'RoutesListComponent']);
  let startPoint = { ...startLocation };
  if (startLocation.type === 'terminal' && startLocation.symbolCode === 'ANY') {
    startPoint = {
      ...startLocation,
      type: 'location',
    };
  }

  let endPoint = { ...endLocation };
  if (endLocation.type === 'terminal' && endLocation.symbolCode === 'ANY') {
    endPoint = {
      ...endLocation,
      type: 'location',
    };
  }

  const crossDockingOperationsStepIndexes = (
    route.routes[0].mixedTransport?.crossDockingOperations ?? []
  ).map((operation) => operation.afterStepIndex + 1);

  return (
    <>
      {crossDockingOperationsStepIndexes.includes(stepIndex) && (
        <div className="cross-docking-text">
          <span>{t('RoutesListComponent:CrossDocking')}</span>
        </div>
      )}
      <RouteShoulderContainer>
        <LocationOrTerminalPoint value={startPoint} branchItem={startPoint}>
          {(primary, _secondary, symbolCode) => {
            return (
              <div className="place__wrapper left">
                <div className="short__name">
                  {!symbolCode || symbolCode === '' ? primary[0] : symbolCode}
                </div>
                <div className="full__place">{primary.join(', ')}</div>
              </div>
            );
          }}
        </LocationOrTerminalPoint>
        <div className="line__wrapper">
          {deliveryDays > 0 && (
            <div className="days">
              {deliveryDays}{' '}
              {deliveryDays === 1 ? t('Common:DeliveryTimeDay') : t('Common:DeliveryTimeDays')}
            </div>
          )}
          <div className="line">
            <KeyboardArrowRightRoundedIcon />
          </div>
          <div className="types__of_transport">
            {routeStepTypes.map((t, index) => {
              const Icon = TransportIcons(t);
              const text = routeStepCargoTypes[index];

              return (
                <div className="transport-type-wrapper" key={`route-shoulder__icons--${t}`}>
                  {routeParams.cargoType === 'fclFtl' && (
                    <span className="transport-type">
                      {index !== 0 && ', '}
                      {text}
                    </span>
                  )}
                  <Icon />
                </div>
              );
            })}
          </div>
        </div>
        <LocationOrTerminalPoint value={endPoint} branchItem={endPoint}>
          {(primary, _secondary, symbolCode) => {
            return (
              <div className="place__wrapper left">
                <div className="short__name">
                  {!symbolCode || symbolCode === '' ? primary[0] : symbolCode}
                </div>
                <div className="full__place">{primary.join(', ')}</div>
              </div>
            );
          }}
        </LocationOrTerminalPoint>
      </RouteShoulderContainer>
    </>
  );
};

export default RouteShoulder;
